import React from 'react';
import { Typography, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import PaymentMethodsManager from '../components/payments/PaymentMethodsManager';

const { Title } = Typography;

const PaymentMethodsAdmin: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div>
      <Button
        type="link"
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate('/configuracion')}
        style={{ padding: 0, marginBottom: 16 }}
      >
        Volver a Configuración
      </Button>
      <div style={{ marginBottom: '24px' }}>
        <Title level={2}>Gestión de Formas de Pago</Title>
      </div>

      <PaymentMethodsManager />
    </div>
  );
};

export default PaymentMethodsAdmin;